import { useEffect, useState } from 'react';
import { CalendarService } from '@services/CalendarService';
import { isDateInArray } from '@utils/date';

// для кеширования запроса календаря, чтобы отправлялся только один запрос на все вызовы useWorkCalendar
let fetchCalendarPromise: Promise<any> | null = null;

export const useWorkCalendar = (enabled: boolean) => {
    // стандартные выходные - суббота, воскресенье
    const defaultHolidays = [0, 6];

    const [extraWorkingDays, setExtraWorkingDays] = useState<Date[]>([]);
    const [extraHolidays, setExtraHolidays] = useState<Date[]>([]);

    useEffect(() => {
        if (!enabled) return;
        if (!fetchCalendarPromise) {
            fetchCalendarPromise = CalendarService.fetchCalendar().then((response) => {
                const workCalendar = response.data.workTimeDays;
                const workingDays = workCalendar.workingDays.map(prepareDate);
                const holidays = workCalendar.holidays.map(prepareDate);
                return { workingDays, holidays };
            });
        }
        fetchCalendarPromise.then((workCalendar) => {
            setExtraWorkingDays(workCalendar.workingDays);
            setExtraHolidays(workCalendar.holidays);
        });
    }, [enabled]);

    const prepareDate = (date: Date) => {
        const d = new Date(date);
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    };

    const isHoliday = (date: Date) => {
        if (isDateInArray(extraWorkingDays, date)) return false;
        if (isDateInArray(extraHolidays, date)) return true;
        if (defaultHolidays.includes(date.getDay())) return true;

        return false;
    };

    return {
        isHoliday,
    };
};
